import { useState } from 'react'
import intl from 'react-intl-universal'
import { useOrderVolumeContext } from '../../context'
import { OrdersFilter as Filter } from 'components/orders-filter'
import { verifyIsFiltered } from 'utils/custom-functions'

import * as S from './styled'
import { IconFilterActive } from 'components/icons/icn-filter-active.icon'
import { IconFilterInactive } from 'components/icons/icn-filter-inactive.icon'
import Sidebar from 'components/sidebar'
import ButtonIcon from 'components/button-icon'

const OrderVolumeFilter = () => {
  const { setOrderVolumeFilter, filter } = useOrderVolumeContext()

  const [openFilter, setOpenFilter] = useState(false)
  const handleClose = () => setOpenFilter(false)

  const refresh = (filters) => {
    setOrderVolumeFilter({ ...filters })
    handleClose()
  }

  const getIconFilter = () => verifyIsFiltered(filter) ? <IconFilterActive fillColor='#55c9d8'  /> : <IconFilterInactive />;

  return (
    <S.Wrapper>
      <ButtonIcon
        onClick={() => setOpenFilter(prevState => !prevState)}
        buttonType="secondary"
        buttonText={intl.get('filters.filter')}
        buttonIcon={getIconFilter()}
        style={{ width: '170px' }}
      />

      <Sidebar
        visible={openFilter}
        triggerClose={() => setOpenFilter(false)}
      >
        <Filter
          handleSearch={refresh}
          filtersDefault={filter}
          isOrderVolume
        />
      </Sidebar>
    </S.Wrapper>
  )
}

export default OrderVolumeFilter
